import SettingsSlider from './SettingsSlider';

export default SettingsSlider;
